import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { colors } from 'Constants';
import { Footnote } from 'Components/core';

function hexToRgb(hex, alpha) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(
      ${parseInt(result[1], 16)},
      ${parseInt(result[2], 16)},
      ${parseInt(result[3], 16)},
      ${alpha || 1})`
    : undefined;
}

const Table = styled.table`
  border-collapse: collapse;
  tr > * {
    padding: 8px;
    ${props => props.center && css(`text-align: center;`)}
  }

  th {
    font-weight: normal;
    text-align: left;
  }
 

 

 
`;

export default props => {
  // TODO: Switch to Case when RRD sends consistently cased data
  const decodeHeader = header => {
    const map = {
      deductible: 'Deductible',
      officevisit: 'Office Visit',
      'out-of-pocket': 'Out-of-Pocket',
      pharmacyChartSection: 'Pharmacy'
    };
    return map[header];
  };

  const { headers, sets,gotDocType } = props;

  const headerColors=   ['#ffffff',"#012169","#0079C2","#f0752f","#69B3E7",'#ABAD00','#012169']
  const subHeaderColors=['#434445',"#344581","#128ACB","#f28d4b","#7DC2EB",'#b9ba3b','#344581']
  const contentColor=['#e3e3e4'
  ,"#d4d6e6","#d4d6e6",
  "#d9eaf8","#d9eaf8",
  '#fde6d1','#fde6d1',
  '#9ECFEF','#9ECFEF',
  '#d6d769','#d6d769'
  ,"#d4d6e6","#d4d6e6"
];

const borderRight={borderRight: '4px solid #ffffff'};
  return (
    <div style={{ overflowX: 'auto' }}>
      <Table
        border
        color1="#666666"
        color2={colors.accent}
        color3="#649b41"
        color4="#f15e3f"
      >
        <tbody>
          {headers && [
            <tr key="headers">
              {headers.map(({ type, name }, i) => (
                <th style={{textAlign:'center',backgroundColor:headerColors[i],color:'#ffffff', ...borderRight }} colSpan={i===0?0:gotDocType?2:0} key={i}>
                  {name}
                  <br />
                  <Footnote>{type}</Footnote>
                </th>
              ))}
            </tr>,
            gotDocType ? <tr>
              <td style={{backgroundColor:subHeaderColors[0],...borderRight}}></td>
              { headers.slice(1).map((a,index)=>{
                return   <> <td style={{backgroundColor:subHeaderColors[index+1],color:'#ffffff'}}>Doctors in the plan</td>
                  <td style={{backgroundColor:subHeaderColors[index+1],color:'#ffffff',...borderRight}}>Doctors out of the plan</td>
                </>;  
              })
              }

            </tr>:<></>,
            ...sets.map(set => [
              <tr style={{height:0}} key={set.header}>
                 <td style={{height:0,padding:0,paddingBottom:2}}></td>
              </tr>,
              ...set.rows.map((row, j) => (
                <tr className={ j % 2 === 0 ? 'alt-color': ''} key={j}>
                  {row.map((content, k) => {

                      if(k==0 && j==0)
                      {
                        content=`<b>${decodeHeader(set.header)?(decodeHeader(set.header)+'<br/>'):''}</b>${content}`
                      }
                      if(k%2!=0)
                      {
                        borderRight.borderRight='none';
                      }
                      else
                      {
                        borderRight.borderRight=    '4px solid #ffffff';
                      }

                      


return (
                    
  <>
    <td key={k} style={{backgroundColor:contentColor[k],textAlign:k==0?'left':"center",...borderRight}} dangerouslySetInnerHTML={{__html:content}}></td>
  
  </>
);

                  })}
                </tr>
              ))
            ])
          ]}
        </tbody>
      </Table>
    </div>
  );
};
